import { useState, useEffect, ChangeEvent, useMemo } from "react";
import { DatePicker, Form, Tooltip } from "antd";
import { MdTune, MdCalendarToday, MdTraffic, MdOutlineSchedule, MdOutlineVerifiedUser, MdAssignment, MdList } from "react-icons/md";
import Accordion from "./partials/Accordion";
import { useFilters } from "core/features/filters/store";
import {
    Container,
    SelectAntd,
    Wrapper,
    Wrap,
    DisplayColorsDate,
    CheckColor,
    ContentAll,
    StatusSemaforo,
    ContentCheckBoxs,
    ContentOption,
    SearchBox,
    OperationsCount,
    ContainerList,
    ItemLabelDate
} from "./styles";
import useMapData from "../../hooks/useMapData";
import { FiltrosAvancado } from "../../interfaces/Planejamento";
import { amountColorAndDate, amountColorAndDateWindowExecution, Datas, getDatedMount, getDatedMountPersonalizada, getSemanaArray, inferHomogeneousOsListTipo, matchDataAberturaComDatas, montarTextoOS, normalizar, STATUS_SEMAFORO, WindowExecutionData } from "./utils";
import { normalizeAndGroupByDate } from "../MapInfo/utils";
import List from "./partials/List";
import { useFiltersLists } from "core/features/filters/store/lists";
import useOrderService from "../../hooks/useOrderService";
import useModalSelecaoTalhoes from "../../hooks/useFiltro";
import { removerPrefixo } from "../AgendaCampo/utils";
import { limitarCaracteres } from "../ModalPlanejamentoOperacoes/utils";

type Props = {
    filtrosAvancados: FiltrosAvancado;
    dataMapOS?: any;
};

type StatusSemaforoProps = {
    status: number;
    color: string;
};

const STATUS_KEYS = ["emDia", "proximo", "atrasado"] as const;

export function FiltroAcompanhamentoOperacional({ filtrosAvancados, dataMapOS }: Props) {
    const [custom, setCustom] = useState(false);
    const [justificativaAtraso, setJustificativaAtraso] = useState<string | null>(null);
    const [ordemServico, setOrdemServico] = useState<boolean | null>(null);
    const [statusSemaforo, setStatusSemaforo] = useState<StatusSemaforoProps[]>(STATUS_SEMAFORO);
    const [startDate, setStartDate] = useState<any>(null);
    const [range, setRange] = useState<any>(null);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [selectedWindowItems, setSelectedWindowItems] = useState<string[]>([]);
    const [checkedAll, setCheckedAll] = useState(true);
    const [selectedIndicadores, setSelectedIndicadores] = useState<Set<string>>(new Set());
    const { updateFiltrosAvancadosOS } = useFiltersLists();

    const { filtroExecucaoOPeracional, update } = useModalSelecaoTalhoes();
    const OPTIONS_SITUATION = [
        { label: "Todas", value: "0" },
        { label: "Aberta", value: "1" },
        { label: "OS fechada", value: "2" },
    ];

    const [situacao, setSituacao] = useState("1");

    const { Item, useForm } = Form;
    const [form] = useForm();
    const { filters, updateField } = useFilters();
    const { menuName, unidade, safra, filtersAdvanced } = filters;
    const { RangePicker } = DatePicker;
    const [selectedTipo, setSelectedTipo] = useState<string | null>(null);
    const {
        setDatas,
        datas,
        mapInfo,
        setIndicadoresDeDia: updateIndicadoresDeDia,
        setJustificativaAtraso: updateJustificativaAtraso,
        setOrdemServico: updateOrdemServico,
        setRangeDates,
        setNumberRepeted,
        setRangeDatesDeleted,
        setRangeWindows,
        semOS,
        setSemOS,
        setArrayColorsAndDates,
        janelaExecucao,
        setJanelaExecucao,
        statusSemaforo: status,
        setStatusSemaforo: setStatus
    } = useMapData();

    const { data: getOrdemServico, isFetching } = useOrderService({ idUnidade: unidade?.id, idSafra: safra?.id, menuName, situacao });

    const mapListInfo = mapInfo?.features?.filter((feature: any) => {
        return feature.properties?.planosoperacionais && feature.properties?.planosoperacionais.length > 0
    });

    useEffect(() => {
        form.setFieldsValue({
            cultura: !!filtersAdvanced?.cultura ? filtersAdvanced?.cultura : undefined,
            periodoProducao: filtersAdvanced?.safraPeriodo,
            classeOperacao: filtersAdvanced?.classeOperacao,
            operacao: filtersAdvanced?.operacao,
        });
    }, [filtersAdvanced.classeOperacao, filtersAdvanced.cultura, filtersAdvanced.operacao, filtersAdvanced.safraPeriodo]);

    const dayOptionList = [
        {
            title: 'Hoje',
            name: 'hoje',
        },
        {
            title: 'Essa Semana',
            name: 'essa-semana',
        },
        {
            title: 'Personalizado',
            name: 'personalizado',
        },
    ];

    useEffect(() => {
        if (statusSemaforo === null) return;
        let semaforoStatus = statusSemaforo.length === 0 ? STATUS_SEMAFORO : statusSemaforo;
        const datasSemana = getSemanaArray();

        const payload = getPayload();

        if (menuName === "Mapa Cronograma") {

            update({
                ...payload,
                statusSemaforo: undefined,
                datasProgramadas: datasSemana?.map(({ dataPrint, ...rest }) => rest),
            });
        } else if (menuName === "Mapa Semáforo") {
            update({
                ...payload,
                statusSemaforo: semaforoStatus,
            });
        } else if (menuName === "Gestão de O.S.") {
            update({
                ...payload,
            });
        }
    }, [statusSemaforo, menuName, datas, filtrosAvancados]);

    useEffect(() => {
        if (menuName === "Mapa Cronograma") {
            getDatedMount("essa-semana", setCustom, setRange, setDatas);
        }
    }, [menuName]);


    useEffect(() => {
        form.setFieldsValue({
            dataInicio: "",
        });

        if (menuName === "Mapa Cronograma") {
            form.setFieldsValue({
                data: "essa-semana",
            });
        }
        if (menuName === "Mapa Semáforo") {
            form.setFieldsValue({
                data: "",
            });
        }
        setCustom(false);
    }, [menuName])

    useEffect(() => {
        if (datas?.length === 0) return;
        const payload = getPayload();
        update(payload);
    }, [datas]);


    const disabledDate = (current: any) => {
        if (!startDate || !current) return false;

        const diff = current.diff(startDate, "days");

        return diff > 14 || diff < -14;
    };

    useEffect(() => {
        if (!filtersAdvanced?.cultura && !filtersAdvanced?.classeOperacao && !filtersAdvanced?.safraPeriodo) {
            form.resetFields();
            form.setFields([
                {
                    name: 'periodoProducao',
                    errors: ['Período de Produção é obrigatório'],
                },
            ]);
        }
    }, [!filtersAdvanced?.cultura, !filtersAdvanced?.classeOperacao, !filtersAdvanced?.safraPeriodo]);


    function getPayload() {

        const forms = form.getFieldsValue();

        let obj: any = {};

        if (!forms?.periodoProducao) {
            form.setFields([
                {
                    name: 'periodoProducao',
                    errors: ['Período de Produção é obrigatório'],
                },
            ]);
            return;
        }

        if (forms?.periodoProducao) {
            obj.safraPeriodos = [forms.periodoProducao];
        }

        if (forms?.classeOperacao) {
            const itemSelectedOperacao = filtrosAvancados?.operacaoClasses
                ?.map((item: any) => ({
                    operacaoClasseId: item.operacaoClasseId,
                    cor: item.color
                }))
                ?.filter(({ operacaoClasseId }) => forms.classeOperacao?.includes(operacaoClasseId));
            obj.operacaoClasses = itemSelectedOperacao;
        }

        if (forms?.operacao) {
            const itemSelectedOperacao = filtrosAvancados?.operacoes
                ?.map((item: any) => ({
                    operacao: item.descricao,
                    operacaoId: item.operacaoId,
                    cor: item.cor
                }))
                ?.find(({ operacaoId }) => operacaoId === forms.operacao);

            if (itemSelectedOperacao) obj.operacoes = [itemSelectedOperacao];
        }

        if (datas && datas?.length > 0) {
            obj.datasProgramadas = datas.map(({ dataPrint, ...rest }) => rest);
            const allIds = datas?.map((item: any) => item?.dataPrint);
            setSelectedItems(allIds!);
            setCheckedAll(true);
        }

        if (menuName === "Mapa Semáforo") {
            obj.statusSemaforo = statusSemaforo;
        }

        if (menuName === "Mapa Cronograma" && janelaExecucao) {
            obj.operacoesNaoCalendarizadas = true;
            delete obj.datasProgramadas;
        }

        return obj;
    }

    useEffect(() => {
        if (menuName === 'Mapa Semáforo') {
            if (statusSemaforo.length === 0) {
                setStatusSemaforo(STATUS_SEMAFORO);
            }
        } else {
            setStatusSemaforo([]);
        }
    }, [menuName]);

    useEffect(() => {
        updateOrdemServico(ordemServico);
    }, [ordemServico]);

    function insertIndicadoresDeDia(isChecked: boolean, item: string) {
        setSelectedIndicadores(prev => {
            const next = new Set(prev);
            if (isChecked) {
                next.add(item);
            } else {
                next.delete(item);
            }
            updateIndicadoresDeDia(next);
            return next;
        });
    }

    function addStatus(statusSelected: number, checked: boolean, color: string) {
        const key = STATUS_KEYS[statusSelected - 1];
        if (!key) return;

        const checkedCount = Object.values(status).filter(Boolean).length;

        if (checkedCount === 1 && status[key]) {
            return;
        }

        setStatus(prev => ({
            ...prev,
            [key]: !prev[key],
        }));

        setStatusSemaforo(prev => {
            let result;
            if (checked) {
                if (prev.some(item => item.status === statusSelected)) {
                    result = prev;
                }
                result = [...prev, { status: statusSelected, color }];
            } else {
                result = prev.filter(item => item.status !== statusSelected);
            }

            if (!result.some(item => item.status === 3)) {
                insertIndicadoresDeDia(false, "diaEmAtraso");
            }

            if (!result.some(item => item.status === 2)) {
                insertIndicadoresDeDia(false, "diaProximoVencimento");
            }

            return result.sort((a, b) => a.status - b.status);
        });
    }

    function handleSelectItem(id: string) {
        setSelectedItems((prev) => {
            const isSelected = prev.includes(id);
            const newSelected = isSelected
                ? prev.filter((itemId) => itemId !== id)
                : [...prev, id];

            return newSelected;
        });
    }

    function handleSelectWindowItem(id: string) {
        setSelectedWindowItems((prev) => {
            const isSelected = prev.includes(id);
            return isSelected
                ? prev.filter((itemId) => itemId !== id)
                : [...prev, id];
        });
    }

    function handleSelectAll(event: ChangeEvent<HTMLInputElement>) {
        const isChecked = event.target.checked;

        if (janelaExecucao) {
            if (isChecked) {
                setSelectedWindowItems(newDatasWindowExecution.map((item) => item.id));
            } else {
                setSelectedWindowItems([]);
            }
            setCheckedAll(isChecked);
            return;
        }

        if (isChecked) {
            const allIds = datas?.map((item: any) => item?.dataPrint);
            setSelectedItems(allIds!);
            setCheckedAll(true);
        } else {
            setSelectedItems([]);
            setCheckedAll(false);
        }
    }

    function handleChangeJustificativaAtraso(e: any, value: string) {
        setJustificativaAtraso(prev => (prev === value ? null : value));
        updateJustificativaAtraso(e?.target?.checked ? value === "possui" ? true : false : null);
    }

    const checkedCount = Object.values(status).filter(Boolean).length;
    const datasInfoComplete = useMemo(
        () => normalizeAndGroupByDate(mapListInfo, datas!),
        [mapListInfo, datas]
    );

    const newDatas = useMemo(
        () => amountColorAndDate(datas!, datasInfoComplete),
        [datas, datasInfoComplete]
    );
    const newDatasWindowExecution = useMemo(
        () => amountColorAndDateWindowExecution(mapListInfo),
        [mapListInfo]
    );
    const windowIdsKey = useMemo(
        () => newDatasWindowExecution.map((item) => item.id).sort().join(","),
        [newDatasWindowExecution]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const ordemServiceList = useMemo(() => {
        return getOrdemServico?.ordensServicos ?? [];
    }, [getOrdemServico]);

    useEffect(() => {
        if (getOrdemServico) {
            updateFiltrosAvancadosOS(getOrdemServico?.filtrosAvancados);
        }
    }, [getOrdemServico])

    const [searchQuery, setSearchQuery] = useState("");
    const [selectedClasseOperacao, setSelectedClasseOperacao] = useState<string[]>(filtersAdvanced?.classeOperacao || []);
    const [selectedOperacao, setSelectedOperacao] = useState<string | undefined>(filtersAdvanced?.operacao);

    const baseFilteredList = useMemo(() => {
        return (
            ordemServiceList?.filter((item: any) => {
                const matchCultura = filtersAdvanced?.cultura
                    ? item.ocupacaoId === filtersAdvanced.cultura
                    : true;
                const matchPeriodo = filtersAdvanced?.safraPeriodo
                    ? item.safraPeriodoId === filtersAdvanced.safraPeriodo
                    : true;
                const matchClasse =
                    filtersAdvanced?.classeOperacao?.length > 0
                        ? filtersAdvanced?.classeOperacao?.includes(
                            item.operacaoClasseId
                        )
                        : true;
                const matchOperacao = filtersAdvanced?.operacao
                    ? item.operacaoId === filtersAdvanced.operacao
                    : true;

                const matchData = matchDataAberturaComDatas(
                    item.dataAbertura,
                    datas
                );

                return (
                    matchCultura &&
                    matchPeriodo &&
                    matchClasse &&
                    matchOperacao &&
                    matchData
                );
            }) ?? []
        );
    }, [ordemServiceList, filtersAdvanced, datas]);

    const listItem = useMemo(() => {
        let list = baseFilteredList;

        if (selectedClasseOperacao?.length > 0) {
            list = list.filter((item: any) =>
                selectedClasseOperacao.includes(item.operacaoClasseId)
            );
        }

        if (selectedOperacao) {
            list = list.filter(
                (item: any) => item.operacaoId === selectedOperacao
            );
        }

        if (selectedTipo === "os-sem-planos") {
            list = list.filter(
                (item: any) => item.possuiPlanoOperacional === false
            );
        } else if (selectedTipo === "os-com-planos") {
            list = list.filter(
                (item: any) => item.possuiPlanoOperacional === true
            );
        } else if (selectedTipo === "talhoes-sem-plano") {
            list = list.filter(
                (item: any) => item.possuiTalhaoSemPlanoOperacional === true
            );
        }

        const q = searchQuery.trim();
        if (q) {
            const searchTerm = normalizar(q);
            list = list.filter((item: any) =>
                montarTextoOS(item).includes(searchTerm)
            );
        }

        return list;
    }, [baseFilteredList, selectedTipo, searchQuery, selectedClasseOperacao, selectedOperacao]);

    useEffect(() => {
        if (menuName !== "Gestão de O.S.") {
            setSearchQuery("");
            setSelectedTipo(null);
        }
    }, [menuName]);

    useEffect(() => {
        if (menuName !== "Gestão de O.S.") return;
        const q = searchQuery.trim();
        if (!q) return;
        const searchTerm = normalizar(q);
        const searchOnly = baseFilteredList.filter((item: any) =>
            montarTextoOS(item).includes(searchTerm)
        );
        setSelectedTipo(inferHomogeneousOsListTipo(searchOnly));
    }, [searchQuery, baseFilteredList, menuName]);

    function handleSearchList(event: ChangeEvent<HTMLInputElement>) {
        setSearchQuery(event.target.value);
    }

    function handleFieldRadioButton(radioButton: string) {
        setSelectedTipo((prev) => (prev === radioButton ? null : radioButton));
    }

    const CounterListOS = () => {
        return (
            <>
                Ordem de Serviço
                <OperationsCount>{dataMapOS && filtersAdvanced?.safraPeriodo?.length > 0 ? listItem?.length : 0} itens</OperationsCount>
            </>
        )
    }

    useEffect(() => {
        if (menuName === "Mapa Cronograma") {
            if (datas?.length === 0 || datasInfoComplete?.length === 0) return;
            const newDatas = amountColorAndDate(datas!, datasInfoComplete);
            setArrayColorsAndDates(newDatas);
        }
    }, [datas?.length, datasInfoComplete.length]);

    useEffect(() => {
        if (menuName !== "Mapa Cronograma" || !janelaExecucao) {
            if (!janelaExecucao) {
                setRangeWindows([]);
            }
            return;
        }

        if (!windowIdsKey) {
            setSelectedWindowItems([]);
            setRangeWindows([]);
            setCheckedAll(false);
            return;
        }

        setSelectedWindowItems(windowIdsKey.split(","));
        setCheckedAll(true);
    }, [janelaExecucao, windowIdsKey, menuName]);

    const selectedWindowIdsKey = useMemo(
        () => [...selectedWindowItems].sort().join(","),
        [selectedWindowItems]
    );

    useEffect(() => {
        if (!janelaExecucao) return;

        const selectedWindows = newDatasWindowExecution.filter((item) =>
            selectedWindowItems.includes(item.id)
        );

        setRangeWindows(selectedWindows);
        setCheckedAll(
            newDatasWindowExecution.length > 0 &&
            selectedWindowItems.length === newDatasWindowExecution.length
        );
    }, [selectedWindowIdsKey, windowIdsKey, janelaExecucao]);

    useEffect(() => {
        setRangeDates([]);
        setRangeDatesDeleted([]);
        if (janelaExecucao) return;
        const dataComplete = normalizeAndGroupByDate(mapListInfo, datas!).map((item) => item.dateComplete);
        const novo = selectedItems.filter(item => dataComplete.includes(item));
        const d = normalizeAndGroupByDate(mapListInfo, datas!); // tem todos
        const n = d.filter((item) => novo.includes(item.dateComplete)); // menos o deletado

        const codigosRepetidos = mapListInfo
            ?.filter((item: any) => item?.properties?.planosoperacionais?.length > 1)
            ?.map((item: any) => item?.id);

        const codigosRepetidosUnicos = Array.from(
            new Set(codigosRepetidos)
        );

        setNumberRepeted(codigosRepetidosUnicos);
        setRangeDates(n);

        const deletados = d.filter(
            original =>
                !n.some(atual => atual.codigo === original.codigo)
        );

        setRangeDatesDeleted(deletados);
    }, [selectedItems, newDatas.length, janelaExecucao]);


    useEffect(() => {
        const payload = getPayload();
        update(payload);
    }, [janelaExecucao]);

    const showPrintClasseOperacao = filtersAdvanced?.classeOperacao?.length === 0 || filtersAdvanced?.classeOperacao?.length === filtrosAvancados?.operacaoClasses?.length ? "hidden-print" : "";
    const showPrintOperacao = !!!filtersAdvanced?.operacao ? "hidden-print" : "";

    useEffect(() => {
        setStatus({
            atrasado: true,
            emDia: true,
            proximo: true
        });
        setStatusSemaforo(menuName === "Mapa Semáforo" ? STATUS_SEMAFORO : []);
        setSelectedIndicadores(new Set());
        updateIndicadoresDeDia(new Set());
        setJustificativaAtraso(null);
        updateJustificativaAtraso(null);
        setOrdemServico(null);
        updateOrdemServico(null);

        const isMenuGestao = menuName === "Gestão de O.S.";

        const culturas = isMenuGestao ? getOrdemServico?.filtrosAvancados?.ocupacoes : filtrosAvancados?.ocupacoes;
        const periodos = isMenuGestao ? getOrdemServico?.filtrosAvancados?.safraPeriodos : filtrosAvancados?.safraPeriodos;

        const cultura = filtersAdvanced?.cultura;
        const periodo = filtersAdvanced?.safraPeriodo;
        const classeOperacao = filtersAdvanced?.classeOperacao;

        const temCultura = culturas?.some((c: any) => c.ocupacaoId === cultura);
        const temPeriodo = periodos?.some((c: any) => c.safraPeriodoId === periodo);

        updateField("filtersAdvanced", {
            ...filtersAdvanced,
            cultura: temCultura ? cultura : undefined,
            safraPeriodo: temPeriodo ? periodo : undefined,
            classeOperacao,
            operacao: undefined,
        });
    }, [menuName]);

    return (
        <Container>
            <Accordion title="Filtros" icon={MdTune} defaultOpen>
                <Wrapper>
                    <Form
                        form={form}
                        layout="vertical"
                        onValuesChange={(changedValues, allValues) => {
                            let obj: any = {};

                            setSelectedClasseOperacao(allValues?.classeOperacao || []);
                            setSelectedOperacao(allValues?.operacao);

                            if (!allValues?.periodoProducao) {
                                form.setFields([
                                    {
                                        name: 'periodoProducao',
                                        errors: ['Período de Produção é obrigatório'],
                                    },
                                ]);
                                return;
                            }

                            if (allValues?.periodoProducao) {
                                obj.safraPeriodos = [allValues.periodoProducao];
                            }

                            if (allValues?.classeOperacao) {
                                const itemSelectedOperacaoClasses = filtrosAvancados?.operacaoClasses
                                    ?.map((item: any) => ({
                                        operacaoClasseId: item.operacaoClasseId,
                                        cor: item.color,
                                    }))
                                    ?.filter(({ operacaoClasseId }) => allValues.classeOperacao?.includes(operacaoClasseId));
                                obj.operacaoClasses = itemSelectedOperacaoClasses;
                            }

                            if (allValues?.operacao) {
                                const itemSelectedOperacao = filtrosAvancados?.operacoes
                                    ?.map((item: any) => ({
                                        operacao: item.descricao,
                                        operacaoId: item.operacaoId,
                                        cor: item.cor
                                    }))
                                    ?.find(({ operacaoId }) => operacaoId === allValues.operacao);
                                obj.operacoes = [itemSelectedOperacao];
                            }

                            if (datas?.length) {
                                obj.datasProgramadas = datas.map(({ dataPrint, ...rest }) => rest);
                            }

                            if (menuName === "Mapa Semáforo") {
                                obj.statusSemaforo = statusSemaforo;
                            }

                            if (!(changedValues?.data) && !(changedValues?.cultura) && !changedValues?.dataInicio) {
                                update({
                                    ...filtroExecucaoOPeracional,
                                    ...obj,
                                });
                            }
                        }}
                    >
                        <Wrap className="hidden-print">
                            <Item
                                label="Cultura"
                                name="cultura"
                            >
                                <SelectAntd
                                    onChange={(dataValue: any) => {
                                        updateField("filtersAdvanced", {
                                            ...filtersAdvanced,
                                            cultura: dataValue,
                                            safraPeriodo: ''
                                        });
                                        form.setFieldsValue({ periodoProducao: '' });
                                        form.validateFields(["periodoProducao"]).catch(() => { });
                                    }}
                                    showSearch
                                    allowClear
                                    placeholder="Cultura"
                                    optionFilterProp="label"
                                    defaultValue={filtersAdvanced?.cultura}
                                    options={
                                        (
                                            menuName === "Gestão de O.S."
                                                ? getOrdemServico?.filtrosAvancados?.ocupacoes
                                                : filtrosAvancados?.ocupacoes
                                        )
                                            ?.map((item: any) => ({
                                                label: item.nome,
                                                value: item.ocupacaoId,
                                            }))
                                    }
                                />
                            </Item>
                        </Wrap>
                        <Wrap>
                            <Item
                                label="Período de Produção"
                                name="periodoProducao"
                                rules={[{ required: true, message: "Período de Produção é obrigatório" }]}
                            >
                                <SelectAntd
                                    onChange={(dataValue: any) => {
                                        updateField("filtersAdvanced", {
                                            ...filtersAdvanced,
                                            safraPeriodo: dataValue
                                        });
                                    }}
                                    showSearch
                                    placeholder="Período de Produção"
                                    optionFilterProp="label"
                                    defaultValue={filtersAdvanced?.safraPeriodo}
                                    options={
                                        (
                                            menuName === "Gestão de O.S."
                                                ? getOrdemServico?.filtrosAvancados?.safraPeriodos
                                                : filtrosAvancados?.safraPeriodos
                                        )
                                            ?.filter((f: any) =>
                                                filtersAdvanced?.cultura
                                                    ? f.ocupacaoId === filtersAdvanced.cultura
                                                    : true
                                            )
                                            ?.map((item: any) => ({
                                                label: item.nome,
                                                value: item.safraPeriodoId,
                                            }))
                                    }
                                />
                            </Item>
                        </Wrap>
                        <Wrap className={showPrintClasseOperacao}>
                            <Item
                                label="Classe de Operação"
                                name="classeOperacao"
                            >
                                <SelectAntd
                                    onChange={(dataValue: any) => {
                                        const has = filtrosAvancados?.operacoes?.filter(operacao =>
                                            form.getFieldValue('classeOperacao')?.includes(operacao.operacaoClasseId)
                                            && operacao.operacaoId === form.getFieldValue('operacao')
                                        );

                                        updateField("filtersAdvanced", {
                                            ...filtersAdvanced,
                                            classeOperacao: dataValue,
                                            operacao: undefined,
                                        })

                                        if (menuName === "Mapa Cronograma" && janelaExecucao) {
                                            const forms = form.getFieldsValue();

                                            let obj: any = {};
                                            const itemSelectedOperacao = filtrosAvancados?.operacaoClasses
                                                ?.map((item: any) => ({
                                                    operacaoClasseId: item.operacaoClasseId,
                                                    cor: item.color
                                                }))
                                                ?.filter(({ operacaoClasseId }) => forms.classeOperacao?.includes(operacaoClasseId));
                                            obj.operacaoClasses = itemSelectedOperacao;
                                            update({
                                                ...filtroExecucaoOPeracional,
                                                ...obj
                                            });
                                        }

                                        if (filtersAdvanced?.operacao && has?.length === 0) {
                                            form.setFieldsValue({ operacao: '' });
                                        }

                                    }}
                                    allowClear
                                    showSearch
                                    mode="multiple"
                                    maxTagCount={2}
                                    maxTagPlaceholder={(omittedValues) => <span>+{omittedValues.length}</span>}
                                    placeholder="Classe de Operação"
                                    optionFilterProp="label"
                                    defaultValue={filtersAdvanced?.classeOperacao}
                                    options={(filtrosAvancados?.operacaoClasses || [])?.map((item: any) => ({
                                        label: item.descricao,
                                        value: item.operacaoClasseId,
                                    }))}
                                />
                            </Item>
                        </Wrap>
                        <Wrap className={showPrintOperacao}>
                            <Item
                                label="Operação"
                                name="operacao"
                            >
                                <SelectAntd
                                    allowClear
                                    showSearch
                                    placeholder="Operação"
                                    onClear={() => {
                                        updateField("filtersAdvanced", {
                                            ...filtersAdvanced,
                                            operacao: ''
                                        })
                                    }}
                                    onChange={(dataValue: any) => {
                                        updateField("filtersAdvanced", {
                                            ...filtersAdvanced,
                                            operacao: dataValue
                                        })
                                        if (menuName === "Mapa Cronograma" && janelaExecucao) {
                                            let obj: any = {};
                                            const forms = form.getFieldsValue();
                                            const itemSelectedOperacao = filtrosAvancados?.operacoes
                                                ?.map((item: any) => ({
                                                    operacao: item.descricao,
                                                    operacaoId: item.operacaoId,
                                                    cor: item.cor
                                                }))
                                                ?.find(({ operacaoId }) => operacaoId === forms.operacao);

                                            obj.operacoes = [itemSelectedOperacao];
                                            update({
                                                ...filtroExecucaoOPeracional,
                                                ...obj
                                            });

                                        }
                                    }}
                                    defaultValue={filtersAdvanced?.operacao}
                                    optionFilterProp="label"
                                    options={(filtrosAvancados?.operacoes || [])
                                        ?.filter(operacao => form.getFieldValue('classeOperacao')?.includes(operacao.operacaoClasseId))
                                        ?.map((item: any) => ({
                                            label: item.descricao,
                                            value: item.operacaoId,
                                        }))}
                                />
                            </Item>
                        </Wrap>
                        {
                            menuName === "Mapa Cronograma" && (
                                <ContentAll>
                                    <label>
                                        <input type="checkbox" checked={janelaExecucao} onChange={() => setJanelaExecucao(!janelaExecucao)} />
                                        Janela de Execução
                                    </label>
                                    {
                                        mapListInfo?.length > 0 && (
                                            <label>
                                                <input type="checkbox" checked={semOS} onChange={() => setSemOS(!semOS)} />
                                                Planejamento sem O.S
                                            </label>
                                        )
                                    }
                                </ContentAll>
                            )
                        }
                        {
                            !janelaExecucao && (
                                <Wrap>
                                    <Item
                                        label="Data"
                                        name="data"
                                        rules={menuName === 'Mapa Cronograma' ? [{ required: true, message: "Data é obrigatório" }] : []}
                                    >
                                        <SelectAntd
                                            placeholder="Data"
                                            allowClear={menuName === "Gestão de O.S."}
                                            defaultValue={menuName === 'Mapa Cronograma' ? "essa-semana" : null}
                                            onChange={(dataValue: any) => {
                                                getDatedMount(dataValue, setCustom, setRange, setDatas);
                                                if (!dataValue) {
                                                    form.setFieldsValue({ dataInicio: null });
                                                }
                                            }}
                                            options={(dayOptionList || [])?.map((item: any) => ({
                                                label: item.title,
                                                value: item.name,
                                            }))}
                                        />
                                    </Item>
                                </Wrap>

                            )
                        }
                        {
                            custom && !janelaExecucao && (
                                <Wrap>
                                    <Item
                                        label="Data Início"
                                        name="dataInicio"
                                    >
                                        <RangePicker
                                            allowClear={true}
                                            format="DD/MM/YYYY"
                                            value={range}
                                            style={{ width: "100%", height: 40, borderRadius: "8px" }}
                                            onCalendarChange={(dates: any) => {
                                                setRange(dates);
                                                getDatedMountPersonalizada(dates, setDatas, setStartDate);
                                            }}
                                            disabledDate={disabledDate}
                                        />
                                    </Item>
                                </Wrap>
                            )
                        }
                    </Form>
                </Wrapper>
            </Accordion>
            {
                menuName === "Mapa Cronograma" && !janelaExecucao && (
                    <Accordion title="Data Programada" icon={MdCalendarToday} defaultOpen>
                        {mapListInfo?.length > 0 ? (
                            <div>
                                <ContentAll>
                                    <label><input type="checkbox" checked={checkedAll} onChange={handleSelectAll} /> Todos</label>
                                </ContentAll>
                                <DisplayColorsDate>
                                    {
                                        (newDatas || [])?.map((item: Datas, index: number) => (
                                            <label key={index}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedItems.includes(item?.dataPrint!)}
                                                    onChange={() => handleSelectItem(item?.dataPrint!)}
                                                />
                                                <CheckColor backgroundColor={item?.color} />
                                                <div>{item.dataPrint}</div>
                                            </label>
                                        ))
                                    }
                                </DisplayColorsDate>
                            </div>

                        ) :
                            <h3>Não há dados</h3>
                        }
                    </Accordion>
                )
            }
            {
                menuName === "Mapa Cronograma" && janelaExecucao && (
                    <Accordion title="Janela de Execução" icon={MdCalendarToday} defaultOpen>
                        {mapListInfo?.length > 0 ? (
                            <div>
                                <ContentAll>
                                    <label><input type="checkbox" checked={checkedAll} onChange={handleSelectAll} /> Todos</label>
                                </ContentAll>
                                <DisplayColorsDate style={{ marginTop: 10 }}>
                                    {
                                        (newDatasWindowExecution || [])?.map((item: WindowExecutionData, index: number) => (
                                            <label key={index}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedWindowItems.includes(item.id)}
                                                    onChange={() => handleSelectWindowItem(item.id)}
                                                />
                                                <CheckColor backgroundColor={item?.color} />
                                                <div style={{ display: "flex", gap: 5, justifyContent: "space-between", width: "100%" }}>
                                                    <ItemLabelDate>{item.periodoDataInicio} a {item.periodoDataFim}</ItemLabelDate>
                                                    <Tooltip title={removerPrefixo(item.operacaoClasse)}><ItemLabelDate>{limitarCaracteres(removerPrefixo(item.operacaoClasse), 15, true)}</ItemLabelDate></Tooltip>
                                                </div>
                                            </label>
                                        ))
                                    }
                                </DisplayColorsDate>
                            </div>

                        ) :
                            <h3>Não há dados</h3>
                        }
                    </Accordion>
                )
            }
            {
                menuName === "Mapa Semáforo" && (
                    <Accordion title="Status" icon={MdTraffic} defaultOpen>
                        <StatusSemaforo>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={status.emDia}
                                    onChange={(e) => addStatus(1, e.target.checked, "#006400")}
                                    disabled={checkedCount === 1 && status.emDia}
                                /> <CheckColor backgroundColor="#006400" /> Em dia
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={status.proximo}
                                    onChange={(e) => addStatus(2, e.target.checked, "#FFA500")}
                                    disabled={checkedCount === 1 && status.proximo}
                                /> <CheckColor backgroundColor="#FFA500" /> Próximo do Vencimento
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={status.atrasado}
                                    onChange={(e) => addStatus(3, e.target.checked, "#FF0000")}
                                    disabled={checkedCount === 1 && status.atrasado}
                                /> <CheckColor backgroundColor="#FF0000" /> Atrasado
                            </label>
                            <h3><MdOutlineSchedule size={18} />Indicadores de dia</h3>
                            <label>
                                <input
                                    type="checkbox"
                                    disabled={!status.atrasado}
                                    checked={selectedIndicadores.has("diaEmAtraso")}
                                    onChange={(e) => insertIndicadoresDeDia(e.target.checked, "diaEmAtraso")}
                                /> <CheckColor backgroundColor="#FF0000" /> Dias em Atraso
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    disabled={!status.proximo}
                                    checked={selectedIndicadores.has("diaProximoVencimento")}
                                    onChange={(e) => insertIndicadoresDeDia(e.target.checked, "diaProximoVencimento")}
                                /> <CheckColor backgroundColor="#FFA500" /> Dias próximo ao Vencimento
                            </label>
                            <h3><MdOutlineVerifiedUser size={18} />Justificativa de Atraso</h3>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={(e) => handleChangeJustificativaAtraso(e, "possui")}
                                    checked={justificativaAtraso === "possui"} />
                                <CheckColor backgroundColor="#FF0000" /> Possui Justificativa
                            </label>
                            <h3><MdAssignment size={18} />Ordem de Serviço</h3>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={ordemServico!}
                                    onChange={(e) => setOrdemServico(e.target.checked)} />
                                <CheckColor backgroundColor="linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)" /> Possui O.S
                            </label>
                        </StatusSemaforo>
                    </Accordion>
                )
            }
            {
                menuName === "Gestão de O.S." && (
                    <Accordion title={<CounterListOS />} icon={MdList} withPadding={false} defaultOpen>
                        <ContentCheckBoxs>
                            <ContentOption>
                                <input type="radio" onClick={() => handleFieldRadioButton('os-sem-planos')} id="os-sem-planos" name="os-tipo" checked={selectedTipo === 'os-sem-planos'} />
                                <label htmlFor="os-sem-planos">O.S. sem Plano</label>
                            </ContentOption>
                            <ContentOption>
                                <input type="radio" onClick={() => handleFieldRadioButton('os-com-planos')} id="os-com-planos" name="os-tipo" checked={selectedTipo === 'os-com-planos'} />
                                <label htmlFor="os-com-planos">O.S. com Plano</label>
                            </ContentOption>
                            <ContentOption>
                                <input type="radio" onClick={() => handleFieldRadioButton('talhoes-sem-plano')} id="talhoes-sem-plano" name="os-tipo" checked={selectedTipo === 'talhoes-sem-plano'} />
                                <label htmlFor="talhoes-sem-plano">Talhões sem Plano</label>
                            </ContentOption>
                        </ContentCheckBoxs>
                        <SearchBox>
                            <SelectAntd
                                style={{ width: 200 }}
                                onChange={(dataValue: any) => {
                                    setSituacao(dataValue);
                                }}
                                value={situacao}
                                placeholder="Situação"
                                optionFilterProp="label"
                                options={OPTIONS_SITUATION}
                            />
                            <input
                                type="search"
                                value={searchQuery}
                                onChange={handleSearchList}
                                placeholder="Pesquisar"
                            />
                        </SearchBox>
                        <ContainerList>
                            {dataMapOS && filtersAdvanced?.safraPeriodo?.length > 0 && <List listItem={listItem} isFetching={isFetching} dataMapOS={dataMapOS} />}
                        </ContainerList>
                    </Accordion>
                )
            }

        </Container>
    );
}
